<div id="pause" class="d-flex align-items-center justify-content-center" role="alert" aria-valuetext="alert loading" aria-live="assertive" aria-valuemin="0" aria-valuemax="100">
    <div id="spinner" aria-busy="true">loading</div>
</div>